module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-on-center close-picker",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page"
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.refreshUBODetails(false)
      }
    }
  }, [_c('div', {
    staticClass: "page-content infinite-scroll",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "listPage"
  }, [_c('back-button'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pilotageTabButtonContainer pilotageTabButtonContainerRegister"
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": _vm.projectsList.length ? '33' : '50'
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink upperLeftRadius filterFontSize",
    class: [_vm.currentTab === 'Documents' ? 'tabActive' : 'tabUnactive'],
    attrs: {
      "tab-link": ".documentsTab"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('Documents')
      }
    }
  }, [_c('span', {
    staticClass: "showLargeScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.docs_label', {
    provider: _vm.currentSupplier.SocialReason
  })) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "showSmallScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.docs_label_small')) + "\n              ")])])], 1), _vm._v(" "), (_vm.projectsList.length) ? _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "33"
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink filterFontSize",
    class: [_vm.currentTab === 'Projects' ? 'tabActive' : 'tabUnactive'],
    attrs: {
      "tab-link": ".projectsTab"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('Projects')
      }
    }
  }, [_c('span', {
    staticClass: "showLargeScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.projects_label', {
    provider: _vm.currentSupplier.SocialReason
  })) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "showSmallScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.projects_label_small')) + "\n              ")])])], 1) : _vm._e(), _vm._v(" "), _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": _vm.projectsList.length ? '33' : '50'
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink upperRightRadius filterFontSize",
    class: [_vm.currentTab === 'SellerInformation' ? 'tabActive' : 'tabUnactive'],
    attrs: {
      "tab-link": ".sellerInformationTab"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentTab('SellerInformation')
      }
    }
  }, [_c('span', {
    staticClass: "showLargeScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.info_label', {
    provider: _vm.currentSupplier.SocialReason
  })) + "\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "showSmallScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.info_label_small')) + "\n              ")])])], 1)], 1)], 1), _vm._v(" "), (_vm.activatePaymentsSpinner) ? _c('spinner') : _c('f7-tabs', [_c('f7-tab', {
    staticClass: "documentsTab",
    attrs: {
      "no-gutter": "",
      "active": _vm.projectsList.length === 0
    }
  }, [(_vm.activateProviderSpinner) ? _c('spinner') : _c('div', [_vm._l((_vm.documentsList), function(document) {
    return (document.Type !== 'PROOF_OF_ADDRESS') ? _c('document-general-info', {
      key: document.IdDocument,
      attrs: {
        "document": document,
        "seller": _vm.currentSupplier,
        "shareholder": false
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "shareholderNumberLine"
  }, [_c('div', {
    staticClass: "shareholderNumberLineTitleQuestion showLargeScreenOnly"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('suppliers.nb_of_shareholders')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "shareholderNumberLineTitleQuestion showSmallScreenOnly",
    staticStyle: {
      "grid-column-start": "1",
      "grid-column-end": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('suppliers.nb_of_shareholders')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "selectionBlocLine showLargeScreenOnly"
  }, _vm._l((_vm.availableShareholderNumber), function(availableNumber) {
    return _c('div', {
      staticClass: "selectionBloc",
      class: {
        selectionBlocActive: _vm.numberOfShareholder === availableNumber
      },
      on: {
        "click": function($event) {
          return _vm.updateNumberOfShareholder(availableNumber, $event)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(availableNumber) + "\n                ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "selectionBlocLine showSmallScreenOnly",
    staticStyle: {
      "grid-column-start": "1",
      "grid-column-end": "3"
    }
  }, _vm._l((_vm.availableShareholderNumber), function(availableNumber) {
    return _c('div', {
      staticClass: "selectionBloc",
      class: {
        selectionBlocActive: _vm.numberOfShareholder === availableNumber
      },
      on: {
        "click": function($event) {
          return _vm.updateNumberOfShareholder(availableNumber, $event)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(availableNumber) + "\n                ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "importFileButton"
  }, [_c('span', {
    staticClass: "fileClickButton",
    on: {
      "click": function($event) {
        return _vm.callUBOinstitutionalSource($event)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('suppliers.ask_institut_UBO')) + "\n                ")])])]), _vm._v(" "), _vm._l((_vm.shareholders), function(shareholder) {
    return _c('div', {
      key: shareholder.orderNumber,
      attrs: {
        "expanded": !shareholder.IsLegalRepresentative
      }
    }, [_c('div', {
      staticClass: "accordionTitleInformation background-supplier-document-form"
    }, [_c('div', {
      staticClass: "shareholdersInformationGrid"
    }, [_c('div', {
      staticClass: "shareholderDocumentsTitle showLargeScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.nme')) + " :\n                    "), (shareholder.Source !== 'Manuel') ? _c('span', [_vm._v(_vm._s(shareholder.LastName))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shareholder.LastName),
        expression: "shareholder.LastName"
      }],
      staticClass: "nameFormControl",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('suppliers.shareholder_lastname_placeholder') + ' ' + shareholder.OrderNumber
      },
      domProps: {
        "value": (shareholder.LastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shareholder, "LastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "shareholderDocumentsTitle showSmallScreenOnly",
      staticStyle: {
        "grid-column-start": "1",
        "grid-column-end": "3"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.nme')) + " :\n                    "), (shareholder.Source !== 'Manuel') ? _c('span', [_vm._v(_vm._s(shareholder.LastName))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shareholder.LastName),
        expression: "shareholder.LastName"
      }],
      staticClass: "nameFormControl",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('suppliers.shareholder_lastname_placeholder') + ' ' + shareholder.OrderNumber
      },
      domProps: {
        "value": (shareholder.LastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shareholder, "LastName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "shareholderDocumentsTitle showLargeScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.fist_nm')) + " :\n                    "), (shareholder.Source !== 'Manuel') ? _c('span', [_vm._v(_vm._s(shareholder.FirstName))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shareholder.FirstName),
        expression: "shareholder.FirstName"
      }],
      staticClass: "nameFormControl",
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('suppliers.shareholder_firstname_placeholder') + ' ' + shareholder.OrderNumber,
        "disabled": shareholder.Source !== 'Manuel'
      },
      domProps: {
        "value": (shareholder.FirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shareholder, "FirstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "shareholderDocumentsTitle showSmallScreenOnly",
      staticStyle: {
        "grid-column-start": "1",
        "grid-column-end": "3"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.fist_nm')) + " :\n                    "), (shareholder.Source !== 'Manuel') ? _c('span', [_vm._v(_vm._s(shareholder.FirstName))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shareholder.FirstName),
        expression: "shareholder.FirstName"
      }],
      staticClass: "nameFormControl",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('suppliers.shareholder_firstname_placeholder') + ' ' + shareholder.OrderNumber
      },
      domProps: {
        "value": (shareholder.FirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shareholder, "FirstName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "percentageDetentionLabel"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('suppliers.percentage_detention')) + "\n                    "), (shareholder.Source !== 'Manuel') ? _c('span', [_vm._v(_vm._s(shareholder.PercentageDetention))]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shareholder.PercentageDetention),
        expression: "shareholder.PercentageDetention"
      }],
      staticClass: "miniFormControl",
      attrs: {
        "type": "text",
        "disabled": shareholder.Source !== 'Manuel'
      },
      domProps: {
        "value": (shareholder.PercentageDetention)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shareholder, "PercentageDetention", $event.target.value)
        }
      }
    }), _vm._v("\n                      %\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "isLegalRepresentativeLabel"
    }, [(shareholder.Source !== 'Manuel') ? _c('b-form-checkbox', {
      attrs: {
        "disabled": (_vm.oneShareholderIsLegalRepresentative && shareholder != null &&
            !shareholder.IsLegalRepresentative) ||
          shareholder.Source !== 'Manuel',
        "value": 1,
        "unchecked-value": 0
      },
      model: {
        value: (_vm.shareholders[shareholder.OrderNumber - 1].IsLegalRepresentative),
        callback: function($$v) {
          _vm.$set(_vm.shareholders[shareholder.OrderNumber - 1], "IsLegalRepresentative", $$v)
        },
        expression: "shareholders[shareholder.OrderNumber - 1].IsLegalRepresentative"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('suppliers.is_legal_representative_label')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (shareholder.Source === 'Manuel') ? _c('a', {
      attrs: {
        "href": "#",
        "title": _vm.$t('suppliers.remove_shareholder')
      },
      on: {
        "click": function($event) {
          return _vm.removeShareholder(shareholder)
        }
      }
    }, [_c('i', {
      staticClass: "icon button-delete f7-icons",
      staticStyle: {
        "margin-right": "-10px",
        "margin-top": "-2px"
      }
    }, [_vm._v("close")])]) : _vm._e()], 1)])]), _vm._v(" "), (!shareholder.IsLegalRepresentative) ? _c('div', _vm._l((shareholder.Documents), function(document) {
      return (_vm.updatedShareholders) ? _c('document-general-info', {
        key: document.IdDocument,
        attrs: {
          "document": document,
          "seller": _vm.currentSupplier,
          "shareholder": shareholder
        }
      }) : _vm._e()
    }), 1) : _vm._e()])
  }), _vm._v(" "), (parseInt(_vm.numberOfShareholder) < (_vm.availableShareholderNumber.length - 1)) ? _c('div', {
    staticClass: "addShareholderLine",
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": _vm.addShareholder
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "f7": "add"
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('suppliers.add_shareholder')) + "\n            ")], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-start"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-9"
  }, [(_vm.currentSupplier.Status !== '31') ? _c('button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateFolderStatus('31')
      }
    }
  }, [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v("\n                " + _vm._s(_vm.$t('suppliers.close_doc_group')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.currentSupplier.Status === '31') ? _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "font-size": "20px",
      "color": "green"
    }
  }, [_vm._v("\n                Compte Client Vérifié\n                "), _c('f7-icon', {
    staticClass: "greenIcon",
    attrs: {
      "fa": "check"
    }
  })], 1) : _vm._e()])])], 1), _vm._v(" "), (_vm.projectsList.length) ? _c('f7-tab', {
    staticClass: "projectsTab",
    attrs: {
      "no-gutter": "",
      "active": _vm.projectsList.length > 0
    }
  }, [_c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isPayments": true,
      "received": true,
      "filterType": 'list',
      "aloneTab": false,
      "propedServiceId": '6'
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  }), _vm._v(" "), _c('project-details', {
    attrs: {
      "projectsInformation": _vm.projectsList
    }
  }), _vm._v(" "), _c('cm-pagination', {
    attrs: {
      "firstIndex": _vm.paginationObject.firstIndex,
      "maxResultsByPage": _vm.paginationObject.maxResults,
      "nbResultsTotal": _vm.paginationObject.nbResultsTotal,
      "refreshEvent": _vm.paginationObject.refresh
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('f7-tab', {
    staticClass: "sellerInformationTab",
    attrs: {
      "no-gutter": ""
    }
  }, [_c('div', {
    staticClass: "sellerInformationTitle"
  }, [_c('h4', [_vm._v(_vm._s(_vm.currentSupplier.SocialReason))])]), _vm._v(" "), _c('div', {
    staticClass: "two-column-grid-container"
  }, _vm._l((_vm.showableSupplierData), function(key) {
    return (_vm.currentSupplier[key] && _vm.currentSupplier[key] !== '') ? _c('div', {
      key: key,
      staticClass: "form-group"
    }, [_c('form-read-group-label-input', {
      attrs: {
        "idLabel": _vm.$t('suppliers.general_info.' + key),
        "inputValue": _vm.showSellerDetailValue(key, _vm.currentSupplier[key]),
        "statusIcon": _vm.getStatusIcon(key, _vm.currentSupplier[key])
      }
    })], 1) : _vm._e()
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row rowSearchBar"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6abd41ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6abd41ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/SupplierDetailPage.vue
// module id = 2388
// module chunks = 2